


























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Widget from "@/shared/components/Widget.vue";
import * as routes from "@/employee/route-names";

@Component({
  components: {
    Widget
  }
})
export default class ContributionPlannerLearnMore extends Vue {
  routes = routes;

  dismissLearnMore (): void {
    this.$router.push({ name: routes.ContributionPlanner });
  }
}
